import styled from 'styled-components';
import { Col } from 'react-materialize';

export default styled(Col)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 25px !important;
`;
